export default function handleSearchForm() {

    $('body').on('click', '.js-search-toggle', function () {
        $(this).parent().toggleClass('open');

        if ($(this).parent().hasClass('open')) {
            $(this).parent().find('.overlay').fadeIn();
            $(this).parent().find('.search-form').fadeIn(400, function () {
                $(this).find('input').focus();
            });
        } else {
            $(this).parent().find('.overlay').fadeOut();
            $(this).parent().find('.search-form').fadeOut().css('display', 'flex');
        }
    }).on('click', '.js-search-overlay', function(){
        $(this).parent().removeClass('open');
        $(this).fadeOut();
        $(this).next('.search-form').fadeOut();
    })
}
